import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

export function Skeleton({ className }: { className?: string }): ReactNode {
  return (
    <div
      aria-hidden
      className={cn('animate-pulse rounded-xs bg-[color:var(--color-skeleton)]', className)}
    />
  );
}

/** Rows at the real row height, so the page does not jump when data replaces the skeleton. */
export function TableSkeleton({ rows = 6 }: { rows?: number }): ReactNode {
  return (
    <div aria-hidden className="flex flex-col gap-px">
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton key={index} className="h-[var(--row-height)] w-full" />
      ))}
    </div>
  );
}
